export const TASKCATEGORY_LOADING = "TASKCATEGORY_LOADING";
export const TASKCATEGORY_RESET = "TASKCATEGORY_RESET";
export const GET_TASKCATEGORY = "GET_TASKCATEGORY";
export const GET_TASKCATEGORY_SUCCESS = "GET_TASKCATEGORY_SUCCESS";
export const GET_TASKCATEGORY_FAIL = "GET_TASKCATEGORY_FAIL";
export const DELETE_TASKCATEGORY = "DELETE_TASKCATEGORY";
export const DELETE_TASKCATEGORY_SUCCESS = "DELETE_TASKCATEGORY_SUCCESS";
export const DELETE_TASKCATEGORY_FAIL = "DELETE_TASKCATEGORY_FAIL";
export const UPDATE_TASKCATEGORY = "UPDATE_TASKCATEGORY";
export const UPDATE_TASKCATEGORY_SUCCESS = "UPDATE_TASKCATEGORY_SUCCESS";
export const UPDATE_TASKCATEGORY_FAIL = "UPDATE_TASKCATEGORY_FAIL";
export const ADD_NEW_TASKCATEGORY = "ADD_NEW_TASKCATEGORY";
export const ADD_TASKCATEGORY_SUCCESS = "ADD_TASKCATEGORY_SUCCESS";
export const ADD_TASKCATEGORY_FAIL = "ADD_TASKCATEGORY_FAIL";
